import classnames from 'classnames/bind';
import { useEffect, useState } from 'react';

import type { TCourseProductOptionTypes } from 'services/course.service';
import { lessonService } from 'services/lesson.service';
import type { IUserData } from 'services/user.service';

import Decision from './steps/Decision';
import OrderInfo from './steps/OrderInfo';
import Payment from './steps/Payment';

import Popup from 'ui/Popup/Popup';
import Icon from 'ui/Icon/Icon';

import classes from './BuyPopup.module.scss';
import { analyticsService } from 'services/analytics.service';

import SignupToFlearnPopup from 'components/SignupToFlearnPopup/SignupToFlearnPopup';

const cx = classnames.bind(classes);

interface IProps {
  close: () => void
  user: IUserData
}

type TStep =
  | 'DECISION'
  | 'PAYMENT'
  | 'ORDER_INFO';

export default function BuyPopup({ close, user }: IProps) {
  const [chosenProductOptionType, setChosenProductOptionType] = useState<TCourseProductOptionTypes | undefined> ( undefined);
  const [step, setStep] = useState<TStep>('DECISION');
    const firstLesson = lessonService.useLessons({ courseId: 'how-to-draw', topicOrder: 1, orderInTopic: 1 }).at(0);
  const linkToFreeCourse = firstLesson
  const [popupVisible, setPopupVisible] = useState(false);
  const onNotAuthedClick = () => setPopupVisible(true);

  useEffect(() => {
    analyticsService.logEvent({ type: analyticsService.event.FormStartBuyCourse });
  }, []);

  return (
    <>
        <Popup
      close={close}
      children={startClosingProcess => (
        <div className={classes.__}>
          <div className={classes.close} onClick={startClosingProcess}>
            <Icon icon='Cross'/>
          </div>
          {step !== 'DECISION' && (
            <div
              className={classes.back}
              onClick={() => setStep(({
                'PAYMENT': 'DECISION',
                'ORDER_INFO': 'PAYMENT',
              } as const)[step])}
            >
              <Icon icon='ArrowButton'/>
            </div>
          )}
          <div className={classes.body}>
            <div className={classes.header}>
              <div className={classes.stepWidget}>
                <div className={cx({ stepWidgetItem: true, stepWidgetItemDesk: true, active: step === 'DECISION' })}>о подписке</div>
                <div className={cx({ stepWidgetItem: true, stepWidgetItemDesk: true, active: step === 'PAYMENT' })}>способы оплаты</div>
                <div className={cx({ stepWidgetItem: true, stepWidgetItemDesk: true, active: step === 'ORDER_INFO' })}>подтверждение</div>
                <div className={cx({ stepWidgetItem: true, stepWidgetItemMob: true, active: step === 'DECISION' })}>1</div>
                <div className={cx({ stepWidgetItem: true, stepWidgetItemMob: true, active: step === 'PAYMENT' })}>2</div>
                <div className={cx({ stepWidgetItem: true, stepWidgetItemMob: true, active: step === 'ORDER_INFO' })}>3</div>
              </div>
            </div>
            {step === 'DECISION' &&
              <Decision
                key='DecisionForm'
                // linkToFreeCourse={linkToFreeCourse}
                onNotAuthedClick={onNotAuthedClick}
                next={productOptionType => {
                setStep('PAYMENT');
                setChosenProductOptionType(productOptionType);
              }}
              />
            }
            {step === 'PAYMENT' &&
              <Payment
                user={user}
                chosenProductOptionType={chosenProductOptionType!}
                next={() => setStep('ORDER_INFO')}
              />
            }
            {step === 'ORDER_INFO' && <OrderInfo user={user} next={close} />}
          </div>
        </div>
      )}
    />
    {popupVisible &&
      <SignupToFlearnPopup
        close={() => setPopupVisible(false)}
      />
    }
    </>
  );
}
